import {
  Sparkles, RefreshCcw, CheckCircle2, AlertTriangle, Loader2,
  FileAudio, FileVideo,
} from "lucide-react";

function ResumoBadge({ item, hasResumo }) {
  if (hasResumo) {
    return (
      <span className="inline-flex items-center gap-1 text-emerald-700 text-xs">
        <CheckCircle2 size={14} /> {item.resumo_len} chars
      </span>
    );
  }
  if (item.cache_status === "failed") {
    return (
      <span className="inline-flex items-center gap-1 text-red-600 text-xs" title={item.cache_error}>
        <AlertTriangle size={14} /> Falhou
      </span>
    );
  }
  if (item.cache_status === "processing") {
    return (
      <span className="inline-flex items-center gap-1 text-amber-600 text-xs">
        <Loader2 size={14} className="animate-spin" /> A processar…
      </span>
    );
  }
  return <span className="text-[#978D78] text-xs">—</span>;
}

function TagPills({ item }) {
  const tags = [item.tag1, item.tag2, item.tag3].filter(Boolean);
  if (!tags.length) return null;
  return (
    <div className="flex flex-wrap gap-1 mt-1.5">
      {tags.map((t, i) => (
        <span key={`${item.ID_ConteudoMediaCenter}-tag-${i}`}
          className="inline-block px-2 py-0.5 rounded-full bg-[#F5F2EB] text-[#978D78] text-[10px]">
          {t}
        </span>
      ))}
    </div>
  );
}

function SummaryRow({ item, TipoIcon, isProcessing, onOpen, onGenerate }) {
  const hasResumo = item.resumo_len > 5;
  const id = item.ID_ConteudoMediaCenter;
  return (
    <tr className="border-t border-[#F5F2EB] hover:bg-[#FAF8F3]">
      <td className="px-3 py-2 font-mono text-xs">{id}</td>
      <td className="px-3 py-2">
        <div className="flex items-start gap-2">
          <TipoIcon size={14} className="text-[#978D78] shrink-0 mt-0.5" />
          <div className="min-w-0 flex-1">
            <button onClick={() => onOpen(id)} data-testid={`ms-open-${id}`}
              className="block text-left text-[#0F1829] hover:underline font-medium">
              {item.Descricao}
            </button>
            {hasResumo && (
              <p className="text-xs text-[#6B7280] mt-1 leading-snug" data-testid={`ms-resumo-${id}`}>
                {item.resumo}
              </p>
            )}
            <TagPills item={item} />
          </div>
        </div>
      </td>
      <td className="px-3 py-2 text-center">
        <ResumoBadge item={item} hasResumo={hasResumo} />
      </td>
      <td className="px-3 py-2">
        {item.has_source
          ? <span className="text-emerald-700 text-xs">OK</span>
          : <span className="text-red-600 text-xs">Sem ficheiro</span>}
      </td>
      <td className="px-3 py-2 text-right">
        <button onClick={() => onGenerate(id, hasResumo)}
          disabled={isProcessing || !item.has_source}
          data-testid={`ms-gen-${id}`}
          className={`px-3 py-1.5 rounded text-xs inline-flex items-center gap-1.5 ${hasResumo ? "border border-[#E6E1D6] hover:bg-[#F5F2EB] text-[#0F1829]" : "bg-[#0F1829] text-white hover:bg-[#1a2542]"} disabled:opacity-50`}>
          {isProcessing ? <Loader2 size={12} className="animate-spin" /> : hasResumo ? <RefreshCcw size={12} /> : <Sparkles size={12} />}
          {isProcessing ? "A gerar…" : hasResumo ? "Regenerar" : "Gerar"}
        </button>
      </td>
    </tr>
  );
}

export default function SummaryTable({ items, loading, tipo, processingIds, onOpen, onGenerate }) {
  const TipoIcon = tipo === "V2" ? FileVideo : FileAudio;
  return (
    <div className="bg-white rounded-xl border border-[#E6E1D6] overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-[#F5F2EB] text-[#978D78] uppercase text-[10px] tracking-wider">
          <tr>
            <th className="px-3 py-2 text-left">ID</th>
            <th className="px-3 py-2 text-left">Descrição</th>
            <th className="px-3 py-2 text-center">Resumo</th>
            <th className="px-3 py-2 text-left">Fonte</th>
            <th className="px-3 py-2 text-right">Acções</th>
          </tr>
        </thead>
        <tbody>
          {loading && items.length === 0 ? (
            <tr><td colSpan="5" className="py-10 text-center text-[#978D78]">
              <Loader2 className="animate-spin inline mr-2" size={14} />A carregar…
            </td></tr>
          ) : items.length === 0 ? (
            <tr><td colSpan="5" className="py-10 text-center text-[#978D78]">Nenhum item.</td></tr>
          ) : items.map((it) => (
            <SummaryRow key={it.ID_ConteudoMediaCenter}
              item={it} TipoIcon={TipoIcon}
              isProcessing={processingIds.has(it.ID_ConteudoMediaCenter)}
              onOpen={onOpen} onGenerate={onGenerate} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
